import { useNavigate } from "react-router-dom";
import { ICON_SIZE, TEXT_BADGE, TEXT_SMALL } from "../../../style";

export default function CardGrid({ cards }) {
    const navigate = useNavigate();

    return (
        <div className="border-round bg-gray-100 border-1 border-gray-300">
            <div className="grid grid-nogutter">
                {cards.map((card) => (
                    <div
                        className="col-6 md:col-4 flex flex-column gap-1 align-items-center p-3 cursor-pointer"
                        key={card.title}
                        onClick={() => navigate(card.path, card.state ? { state: card.state } : undefined)}
                    >
                        <i className={`pi ${card.icon || "pi-pencil"} border-circle bg-gray-800 p-3 text-white ${ICON_SIZE}`}></i>
                        <p className={`p-0 m-0 text-center font-semibold ${TEXT_SMALL}`}>{card.title}</p>
                        {card.detail ? <p className={`p-0 m-0 text-center text-color-secondary ${TEXT_BADGE}`}>{card.detail}</p> : null}
                    </div>
                ))}
            </div>
        </div>
    );
}
